




















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  name: 'lb-badge',
})
export default class extends Vue {
  @Prop() private value!: string | number;
  @Prop() private max!: number;
  @Prop({ type: Boolean, default: false }) private isDot!: boolean;
  @Prop({ type: Boolean, default: false }) private hidden!: boolean;
  @Prop({ validator(value) { return ['primary', 'success', 'warning', 'info', 'danger'].indexOf(value) > -1; }}) private type!: string;

  get content() {
    if (this.isDot) { return; }
    const value = this.value;
    const max = this.max;
    if (typeof value === 'number' && typeof max === 'number') {
      return max < value ? `${max}+` : value;
    }
    return value;
  }
}
